import "./App.css";
import React, { lazy, Suspense, memo } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { useAuth } from "./components/AuthRouter/AuthContext";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "antd/dist/antd.css";

import Layout from "./components/boilerPlat/layout";
import PBXTaskManager from "./PBXTaskManager";
import UserWorkspace from "./v2/UserWorkspace";

const Dashboard = lazy(() => import("./components/Dashboard"));
const Calls = lazy(() => import("./components/phone/Calls"));
const BlockedNumbers = lazy(() => import("./lists/BlockedNumbers"));
const Sucess = lazy(() => import("./components/Sucess"));
const ReportList = lazy(() => import("./lists/ReportList"));
const PurchaseNumberList = lazy(() => import("./lists/PurchaseNumberList"));
const LiveCallsReporting = lazy(() => import("./components/phone/LiveCalls"));
const Callhistory = lazy(() => import("./components/phone/Callhistory"));
const ManageUsers = lazy(() => import("./components/phone/ManageUsers"));
const RingGroup = lazy(() => import("./components/phone/RingGroup"));
const Greetings = lazy(() => import("./components/phone/Greetings"));

const Logs = lazy(() => import("./components/Login/Logs"));
const Resetpasword = lazy(() => import("./components/Resetpassword"));
const ChangePassword = lazy(() => import("./components/ChangePassword"));
const VerifyEmail = lazy(() => import("./components/VerifyEmail"));

const privateRoutes = [
  { path: "dashboard", component: Dashboard },
  { path: "change-password", component: ChangePassword },
  { path: "admin-dashboard", component: Dashboard },
  { path: "success", component: Sucess },
  { path: "report-list", component: ReportList },
  { path: "purchase-number-list", component: PurchaseNumberList },
  { path: "block-number", component: BlockedNumbers },
  { path: "live-calls-reporting", component: LiveCallsReporting },
  { path: "extension-live-calls", component: LiveCallsReporting },
  { path: "calls", component: Calls },
  { path: "call-history", component: Callhistory },
  { path: "manage-users", component: ManageUsers },
  { path: "ring-group", component: RingGroup },
  { path: "greetings", component: Greetings },
];

const LoadingFallback = memo(() => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "18px",
      color: "#666",
    }}
  >
    Loading...
  </div>
));

LoadingFallback.displayName = "LoadingFallback";

const PrivateRoute = memo(() => {
  const { loggedIn } = useAuth();
  return loggedIn ? <Outlet /> : <Navigate to="/" replace />;
});

PrivateRoute.displayName = "PrivateRoute";

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Logs initialMode="signIn" />} />
            <Route path="/resetpassword" element={<Resetpasword />} />
            <Route path="/register" element={<Logs initialMode="signUp" />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/pbx-manager" element={<PBXTaskManager />} />
            <Route path="/v2" element={<UserWorkspace />} />
            <Route path="/v2-user" element={<UserWorkspace />} />

              <Route element={<PrivateRoute />}>
                <Route element={<Layout />}>
                  {privateRoutes.map((route) => {
                    const RouteComponent = route.component;

                    return (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={<RouteComponent />}
                      />
                    );
                  })}
                </Route>
              </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>

        <ToastContainer />
      </Router>
    </div>
  );
}

export default memo(App);
